import { useState } from "react";

import { monthLabel } from "../lib/format";

export interface MonthPoint { month: string; value: number; label: string }

/** Monthly columns, one series. One hue (the section title names the series,
 *  so no legend); rounded data end, square baseline; a 2px surface gap between
 *  columns; a hover/focus tooltip on every column with a hit target the full
 *  height of the plot; a table view for anyone who cannot use the chart. */
export function MonthBars({ points, title }: { points: MonthPoint[]; title: string }) {
  const [hover, setHover] = useState<number | null>(null);
  const [asTable, setAsTable] = useState(false);
  if (!points.length) return <p className="empty">No dated rows.</p>;
  const max = Math.max(...points.map((p) => p.value), 1);

  return (
    <div className="monthbars">
      <div className="chart-tools">
        <button className="link-btn" onClick={() => setAsTable((t) => !t)} aria-pressed={asTable}>
          {asTable ? "Show chart" : "Show as table"}
        </button>
      </div>
      {asTable ? (
        <table className="grid compact">
          <thead><tr><th>Month</th><th className="n">{title}</th></tr></thead>
          <tbody>{points.map((p) => <tr key={p.month}><td>{monthLabel(p.month)}</td><td className="n">{p.label}</td></tr>)}</tbody>
        </table>
      ) : (
        <div className="mb-plot" role="img" aria-label={`${title} by month`}>
          <div className="mb-cols">
            {points.map((p, i) => (
              <button key={p.month} className="mb-col" onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(null)}
                      onFocus={() => setHover(i)} onBlur={() => setHover(null)}
                      aria-label={`${monthLabel(p.month)}: ${p.label}`}>
                <span className="mb-fill" style={{ blockSize: `${Math.max((p.value / max) * 100, 1)}%` }} />
                {hover === i && (
                  <span className="tooltip" role="tooltip">
                    <strong>{monthLabel(p.month)}</strong><br />{p.label}
                  </span>
                )}
              </button>
            ))}
          </div>
          <div className="mb-axis">
            {points.map((p, i) => (
              <span key={p.month}>{points.length <= 12 || i % 2 === 0 ? monthLabel(p.month) : ""}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
